import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';
import { TabsPage } from '@pages/dashboard';
import { DrawerState } from 'ion-bottom-drawer';
import { DetailEmployeeActivity, DetailIdle, DetailTrackingActivity } from "../index";
import { cmpDepartmentList } from '@src/components/departmentList/cmp';
import { Storage } from '@ionic/storage';
import { Tracker } from '@providers/activity';
import leaflet from 'leaflet';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { Observable } from 'rxjs';
import { cmpFilterKaryawan } from '@src/components/filterKaryawan/cmp';
// import * as d3 from 'd3';
declare var d3;
@Component({
  selector: 'tracking-activity',
  templateUrl: 'page.html'
})
export class Tracking {

  berita:any = '';
  loading : any;
  url = this.api.url + '/index.php/activity/Location/tracking_location';//mobile
  // url = this.api.url + '/index.php/activity/Location/tracking_all_employee';//web
  data = {
    asset:[],
    selected:{
      department:[]
    },
    user:{
      lat : 0,
      lng : 0,
    },
    style : 'mapbox://styles/mapbox/outdoors-v9',
    // style : 'mapbox://styles/hanafiq/ck29yeqbn3svi1cpulkddp8oh',
    // style : 'mapbox://styles/hanafiq/ck6n4z4vb0qlw1iqqdsyvgrkf',
  };
  state = {
    skeleton : true,
    selected_marker : 'employee',
    employee_selected : this.userApi.data.user_name,
  };

  today = this.helper.getToday();
  parameter : any = {
    employee_id : this.userApi.data.employee_id,
    asset_id: "",
    employee_code : this.userApi.data.code,
    flag : "employee"
  }
  map = mapboxgl.Map;
  marker: any = [];
  drawerOptions: any;
  fileTransfer: FileTransferObject = this.transfer.create();
  // @ViewChild('widgetSearch') private searchBar: Searchbar;
  // @ViewChild('map') mapContainer: ElementRef;
  // map: any;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private modalCtrl     : ModalController,
    private storage       : Storage,
    public trackerProvider   : Tracker,
    private geolocation       : Geolocation,
  ) {
      // this.getAsset();
      this.drawerOptions = {
        handleHeight: 0,
        thresholdFromBottom: 200,
        thresholdFromTop: 200,
        bounceBack: false,
        has_event_panup: true,
        event_panup : () => {
          document.getElementById('area-asset').style.height = "calc(100vh - 170px)";
        },
        has_event_pandown:true,
        event_pandown : () => {
          document.getElementById('area-asset').style.height = "calc(40vh - 100px)";
        },
      };
      mapboxgl.accessToken = this.userApi.tokenMapbox;
      //bikin interval buat check data terbaru setiap 15 detik
    }
    
    ionViewDidEnter() {
      let me = this;
      this.geolocation.getCurrentPosition().then((data) => {
        this.data.user.lat = data.coords.latitude;
        this.data.user.lng = data.coords.longitude;
        this.loadmap();
        // this.getUpdateLocation();
        // this.getAsset();
      });
    }

    loadmap() {
      let me = this;
      this.map = new mapboxgl.Map({
        container: 'map',
        style: this.data.style,
        attributionControl:false,
        zoom: 15,
        center: [this.data.user.lng , this.data.user.lat],
      });
      
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: {
        enableHighAccuracy: true,
        zoom:0
        },
        trackUserLocation: true
      }));
      // var url = 'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_ports.geojson';
      this.map.on('load',() => {
        //with animation 
        this.map.loadImage('./assets/img/location_orange.png',function(error, image) {
          if (error) throw error;
          me.map.addImage('marker-custom', image);
          me.map.loadImage('./assets/img/marker_people.png',(error,img) => {
            if (error) throw error;
            me.map.addImage('marker-people', img);
            me.map.addSource('points', {
              'type': 'geojson',
              'data': me.url+'?flag='+me.state.selected_marker+'&employee_id='+me.parameter.employee_id+'&employee_code='+me.parameter.employee_code+'&asset_id='+me.parameter.asset_id
            });
            me.map.addLayer({
              'id': 'points',
              'type': 'symbol',
              'source': 'points',
              'layout': {
                // get the icon name from the source's "icon" property
                // concatenate the name to get an icon from the style's sprite sheet
                'icon-image': 'marker-people',
                // get the title name from the source's "title" property
                'text-field': ['get', 'title'],
                'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
                'text-offset': [0, 0.6],
                'text-anchor': 'top'
              }
            });
            window.setInterval(function() {
                let options = {
                  zoom : false,
                };
                me.update_location(options.zoom);
            }, 15000);
          }); 
        });

      });    
    }

  update_location(zoom = true){
    let me = this
    d3.json(me.url+'?flag='+me.state.selected_marker+'&employee_id='+me.parameter.employee_id+'&employee_code='+me.parameter.employee_code+'&asset_id='+me.parameter.asset_id,(err, data) => {
      if (err) throw err;
      me.map.getSource('points').setData(data);
      let icon = me.state.selected_marker == 'employee' ? 'marker-people' : 'marker-custom';
      me.map.setLayoutProperty("points","icon-image",icon);
      if (data.features.length == 1) {
        console.log("fly to coordinates");
        me.fly_map_to_coordinates(data.features[0].geometry.coordinates,zoom);
      }
    });
  }

  fly_map_to_coordinates(coordinates,zoom = true){
   if (zoom) {
    this.map.flyTo({
      center: coordinates,
      zoom: 20,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
   }else{
    this.map.flyTo({
      center: coordinates,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
   }
  }

  fly_map_indonesia(){
    this.map.flyTo({
      center: [
        106.819656,
        -6.240224
      ],
      zoom: 5,
      speed: 1,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }

  showKaryawan(){
    let me = this;
    this.loading = this.helper.showLoading("Proses...");
    let params = {
      id:this.userApi.data.Employee_ID,
      active_tab:"none",
    };
    this.repositoryProvider.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {active_tab:params.active_tab,karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Team Profile",level:resp.data.level}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.parameter.employee_id = me.userApi.data.employee_id;
              me.parameter.employee_code = me.userApi.data.code;
              me.state.employee_selected = me.userApi.data.user_name;
            }else{
              me.parameter.employee_id = karyawan.id;
              me.parameter.employee_code = karyawan.nik;
              me.state.employee_selected = karyawan.employee_name;
            }
            // this.showLoading();
            me.update_location();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  findAsset(item,data_state){
    this.state.selected_marker = data_state;
    this.parameter.asset_id = item.id;
    let me = this;
    let icon = me.state.selected_marker == 'employee' ? 'marker-people' : 'marker-custom';
    me.map.setLayoutProperty("points","icon-image",icon);
    if (data_state =='all') {
      me.fly_map_indonesia();
    }
    this.update_location();
  }

  findEmployee(){
    this.state.selected_marker = 'employee';
    let me = this;
    let icon = me.state.selected_marker == 'employee' ? 'marker-people' : 'marker-custom';
    me.map.setLayoutProperty("points","icon-image",icon);

    this.update_location();
  }

  getAsset(){
    let me = this;
    this.state.skeleton = true;
    this.trackerProvider.getAsset(this.parameter).subscribe((resp?:any) => {
      if(resp.success){
        this.data.asset = resp.data;
        // console.log(this.state,this.data.employee);
        try {
          // this.loading.dismiss();
          setTimeout(() => {
            this.state.skeleton = false;
          }, 500);
        } catch (error) {}
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        setTimeout(() => {
          this.state.skeleton = false;
        }, 500);
      } catch (error) {
        
      }
    }); 
  }
  
  
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

  detailAsset(data){
    this.nav.setRoot(DetailTrackingActivity,{data:data});
  }

  showListDepartment(){
    let me = this;
  }

  addSingleMarker(item,class_mark="marker-orange"){
    let el = document.createElement('div');
    el.className = class_mark;
    
    // make a marker for each feature and add to the map
    let mark =  new mapboxgl.Marker(el)
      .setLngLat([item.longitude,item.latitude])
      .addTo(this.map);
    this.marker.push(mark);
    this.map.flyTo({
      center: [
        item.longitude,
        item.latitude
      ],
      zoom: 15,
      speed: 0.9,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }

  addManyMarker(item){
    item.forEach(row => {
      var el = document.createElement('div');
      if (row.flag == 'employee') {
        el.className = 'marker-people';
      }else{
        el.className = 'marker-motor';
      }
      // make a marker for each feature and add to the map
      let mark =  new mapboxgl.Marker(el)
        .setLngLat([row.longitude,row.latitude])
        .addTo(this.map);
      this.marker.push(mark);
    });
    this.map.flyTo({
      center: [
        106.819656,
        -6.240224
      ],
      zoom: 10,
      speed: 0.9,
      curve: 1,
      easing(t) {
        return t;
      },
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/activity/tracking/page.ts